import { ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../data/content';
import { Reveal, Eyebrow } from './Reveal';

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-espresso pb-24 md:pb-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="mb-14 flex flex-col gap-6 md:mb-20 md:flex-row md:items-end md:justify-between">
        <div>
          <Eyebrow>What We Do</Eyebrow>
          <Reveal>
            <h2 className="mt-4 font-serif text-3xl font-light leading-tight text-cream sm:text-4xl lg:text-5xl">
              Three crafts.<br />
              One <span className="italic text-gold">uncompromising</span> standard.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm font-light leading-relaxed text-sand/70 md:text-base">
            From the first sketch to the final walkthrough, every Invicto project is built by our own
            crews, to the same finish standard.
          </p>
        </Reveal>
      </div>

      <div>
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={0.05}>
            <div
              className={`grid items-center gap-8 border-t border-gold/15 py-14 lg:grid-cols-12 lg:py-16 ${
                i === SERVICES.length - 1 ? 'border-b' : ''
              }`}
            >
              <div className="hidden lg:col-span-1 lg:block">
                <span className="font-serif text-5xl font-light italic text-gold">{`0${i + 1}`}</span>
              </div>

              <div className={`lg:col-span-5 ${i % 2 === 1 ? 'lg:order-3' : ''}`}>
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold lg:hidden">{`0${i + 1}`}</p>
                <h3 className="mt-2 font-serif text-3xl font-light text-cream lg:mt-0 lg:text-4xl">{s.title}</h3>
                <p className="mt-4 text-sm font-light leading-relaxed text-sand/70 md:text-base">{s.desc}</p>
                <ul className="mt-6 space-y-2">
                  {s.points.map((p, j) => (
                    <li key={j} className="flex items-center gap-3 text-sm text-sand">
                      <span className="h-1 w-1 rotate-45 bg-gold" />
                      {p}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`service-discuss-${s.id}`}
                  onClick={() => window.dispatchEvent(new CustomEvent('invicto:preset', { detail: s.type }))}
                  className="group mt-7 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-gold transition-colors hover:text-cream"
                >
                  Discuss this service
                  <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>

              <div className={`lg:col-span-6 ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div
                  className="group border border-gold/20"
                  style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 26px), calc(100% - 26px) 100%, 0 100%)' }}
                >
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="h-64 w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105 sm:h-80 lg:h-96"
                  />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
